// extracted by mini-css-extract-plugin
module.exports = {"smartLinkBrandLogo":"smartlink-module--smart-link-brand-logo--2Mb2U"};